import { render } from "./DonationGroupManageCreateForm.vue?vue&type=template&id=7088310f&lang=true"
import script from "./DonationGroupManageCreateForm.vue?vue&type=script&lang=js"
export * from "./DonationGroupManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__